import { render, staticRenderFns } from "./gostergebirimeslesme.vue?vue&type=template&id=2c1a2d4f"
import script from "./gostergebirimeslesme.vue?vue&type=script&lang=js"
export * from "./gostergebirimeslesme.vue?vue&type=script&lang=js"
import style0 from "./gostergebirimeslesme.vue?vue&type=style&index=0&id=2c1a2d4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports